<div class="product-card-price">
  @if (shouldDisplayPrices) {
    @if (isLoading) {
      <app-loading-indicator-base [loadingIndicatorStyle]="eLoadingIndicatorStyle.EMBEDDED"></app-loading-indicator-base>
    }
    @if (!isLoading) {
      @if (priceTemplateData) {
        @if (isUnitPricePricing) {
          @if (priceTemplateData.listUnitPrice?.isOrderPrice) {
            <app-price-format [priceFormat]="priceTemplateData.listUnitPrice" [displayDiscounts]="true"></app-price-format>
          }
          @if (priceTemplateData.customUnitPrice?.isOrderPrice) {
            <app-price-format [priceFormat]="priceTemplateData.customUnitPrice" [displayDiscounts]="true"></app-price-format>
          }
          @if (priceTemplateData.scaleUnitPrice?.isOrderPrice) {
            <app-price-format [priceFormat]="priceTemplateData.scaleUnitPrice" [displayDiscounts]="true"></app-price-format>
          }
        }
        @if (!isUnitPricePricing) {
          @if (priceTemplateData.orderPriceType != undefined) {
            @if (priceTemplateData.orderPriceIsUnitPrice) {
              <app-price-format [priceFormat]="priceTemplateData.orderUnitPrice"></app-price-format>
            }
            @if (!priceTemplateData.orderPriceIsUnitPrice) {
              <app-price-format [priceFormat]="priceTemplateData.orderPricePerPriceQuantity"></app-price-format>
            }
          }
        }
      }
    }
  }

  @if (!shouldDisplayPrices) {
    <app-price-missing-info-icon></app-price-missing-info-icon>
  }
</div>
